<div class="flex flex-col gap-2 pr-2">
	<app-container type="dark" title="General information">
		<div class="flex flex-col gap-6">
			<ng-container
				*ngIf="_selectedMortgage?.transactionType !== transactionType.BRIDGE"
			>
				<h5>Select the mortgage priority</h5>
				<app-mortgage-priority-selector
					[ngModel]="_selectedMortgage?.priority"
					(ngModelChange)="setPriority($event)"
				></app-mortgage-priority-selector>
				<app-priority-warning
					[mortgage]="_selectedMortgage"
				></app-priority-warning>
			</ng-container>
			<hr />
			<div
				#lenderDetails
				[ngClass]="lenderError ? 'border border-red-500' : ''"
			>
				<app-manual-mortgage-lender-details
					[mortgage]="_selectedMortgage"
					[subtitle]="'Selecting a lender is required.'"
					[subtitleClasses]="lenderError ? 'text-red-500' : ''"
					(onLenderRemoved)="onLenderRemoved($event)"
					(onLenderUpdated)="onLenderUpdated($event)"
					(onLenderAdded)="onLenderAdded($event)"
					(onLenderAssociationAdded)="onAddAssociation($event)"
					(onRemoveLenderInvestor)="onRemoveInvestor($event)"
					(onLenderSetAsPrimary)="onLenderSetAsPrimary($event)"
					(onCorrespondenceSolicitorUpdate)="onSolicitorUpdated($event)"
					(onCorrespondenceRemove)="onCorrespondenceRemoved()"
					(onPercentageOfInterestTypeUpdated)="
						onPercentageOfInterestTypeUpdated($event)
					"
					(onLenderPercentageOfInterestDetailsUpdated)="
						onLenderPercentageOfInterestUpdated($event)
					"
					type="light"
				></app-manual-mortgage-lender-details>
			</div>
			<hr />
			<ng-container *ngIf="showChargeTypeDropdown">
				<div class="flex flex-col gap-1" #chargeType>
					<div class="intake-field">
						<div class="text-grey-darker">
							Charge Type<span class="text-red-500">*</span>
						</div>
						<app-charge-type-dropdown
							[forceErrorState]="chargeTypeError"
							[mortgage]="_selectedMortgage"
						></app-charge-type-dropdown>
					</div>
					<div class="flex-1 flex justify-end" *ngIf="chargeTypeError">
						<p class="text-red-500 text-sm">Please select a charge type.</p>
					</div>
				</div>
				<hr />
			</ng-container>
			<div class="flex flex-col gap-6">
				<h5>Miscellaneous Details</h5>
				<div class="intake-field">
					<app-checkbox
						label="Assignment of Rents"
						type="clear"
						[ngModel]="_selectedMortgage?.assignmentOfRents"
						(ngModelChange)="setAssignmentOfRents($event)"
					></app-checkbox>
					<app-checkbox
						label="General Security Agreement"
						type="clear"
						[ngModel]="_selectedMortgage?.generalSecurityAgreement"
						(ngModelChange)="setGeneralSecurityAgreement($event)"
					></app-checkbox>
				</div>
				<div class="intake-field">
					<div class="text-grey-darker">Closing Date</div>
					<app-sale-closing-date
						label=""
						orientation="col"
					></app-sale-closing-date>
				</div>
				<div class="intake-field">
					<div class="text-grey-darker">Commitment Date</div>
					<app-date-picker
						[ngModel]="_selectedMortgage?.commitmentDate"
						(ngModelChange)="setCommitmentDate($event)"
					></app-date-picker>
				</div>
				<div class="intake-field">
					<div class="text-grey-darker">Lender Reference Number</div>
					<app-input
						[ngModel]="_selectedMortgage?.referenceNumber"
						(debounce)="setReferenceNumber($event)"
					></app-input>
				</div>
				<div class="intake-field" *ngIf="_selectedMortgage?.mms">
					<div class="text-grey-darker">Deal ID</div>
					<app-input
						class="flex-1"
						[ngModel]="_selectedMortgage?.dealId"
						(debounce)="setDealId($event)"
					></app-input>
				</div>
			</div>
		</div>
	</app-container>
	<app-container type="dark" title="Particular Remarks">
		<app-text-area
			class="mt-2"
			label="Lender Comments"
			[ngModel]="_selectedMortgage?.remarks"
			(debounce)="setRemarks($event)"
		/>
	</app-container>
	<app-container type="dark" title="Borrower(s)">
		<div class="flex flex-col gap-6">
			<app-sale-clients-search-and-create
				label="Borrower(s)"
				[clientType]="borrowerClientType"
				id="borrower"
			>
			</app-sale-clients-search-and-create>
			<app-sale-clients-search-and-create
				label="Guarantor(s)"
				[clientType]="guarantorClientType"
				[useCustomAdd]="true"
				(onAdd)="addGuarantor($event)"
				(onCreate)="createGuarantor($event)"
				id="guarantor"
			>
			</app-sale-clients-search-and-create>
			<div *ngIf="matterFileType === MatterFileType.PURCHASE">
				<app-mortgage-broker
					[mortgage]="_selectedMortgage"
				></app-mortgage-broker>
			</div>
		</div>
	</app-container>
	<app-container
		type="dark"
		title="Brokerage Details"
		*ngIf="matterFileType === MatterFileType.REFINANCE"
	>
		<app-mortgage-broker [mortgage]="_selectedMortgage"></app-mortgage-broker>
	</app-container>
	<app-container type="dark" title="Property">
		<app-matter-address class="mt-2"></app-matter-address>
	</app-container>
	<app-container type="dark" title="Loan Details">
		<div class="flex flex-col gap-6">
			<app-mortgage-net-amount
				[mortgage]="_selectedMortgage"
			></app-mortgage-net-amount>

			<hr />

			<h5>Interest Rate</h5>
			<div class="intake-field">
				<div class="text-grey-darker">Interest Rate Type</div>
				<app-radio-group
					type="compact"
					[items]="interestRateTypeOptions"
					[ngModel]="_selectedMortgage?.interestRateType"
					(ngModelChange)="setInterestRateType($event)"
				></app-radio-group>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Interest Rate</div>
				<div class="flex gap-2 items-center">
					<ng-container
						*ngIf="_selectedMortgage?.interestRateType === variableRateType"
					>
						<div class="text-grey">Prime</div>
						<app-radio-group
							type="compact"
							[items]="interestRatePrimeOptions"
							[ngModel]="_selectedMortgage?.interestAbovePrime"
							(ngModelChange)="setAbovePrime($event)"
						></app-radio-group>
					</ng-container>
					<app-input
						type="number"
						[ngModel]="_selectedMortgage?.interestRate"
						[endIcon]="ICON.PERCENTAGE"
						(debounce)="setInterestRate($event)"
					></app-input>
				</div>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Calculation Period</div>
				<app-dropdown
					[itemGroups]="[{ items: interestCalculatedOptions }]"
					[readonly]="false"
					[ngModel]="_selectedMortgage?.interestCalculated"
					(debounce)="setInterestCalculated($event)"
					(onSelect)="selectInterestCalculated($event)"
				></app-dropdown>
			</div>

			<hr />

			<h5>Terms</h5>
			<div class="intake-field">
				<div class="text-grey-darker">Term</div>
				<app-input
					[ngModel]="_selectedMortgage?.term"
					(debounce)="setTerm($event)"
				></app-input>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Amortization</div>
				<app-input
					type="number"
					[ngModel]="_selectedMortgage?.amortization"
					(debounce)="setAmortization($event)"
				></app-input>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Standard Charge Term Number</div>
				<app-input
					[ngModel]="_selectedMortgage?.standardChargeTerm"
					[placeholder]="_selectedMortgage?.standardChargeTerm ?? ''"
					(debounce)="setStandardChargeTerm($event)"
				></app-input>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Insurance Amount</div>
				<app-dropdown
					[itemGroups]="[{ items: insuranceAmountOptions }]"
					[ngModel]="selectedInsuranceAmountText"
					(onSelect)="setInsuranceAmount($event?.result?.value)"
				></app-dropdown>
			</div>

			<hr />

			<h5>Payments</h5>
			<div class="intake-field">
				<app-checkbox
					type="clear"
					[ngModel]="_selectedMortgage?.interestOnlyPayments"
					(ngModelChange)="setInterestOnlyPayments($event)"
					>Interest only payments</app-checkbox
				>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Payment Frequency</div>
				<app-dropdown
					[itemGroups]="[{ items: paymentFrequencyOptions }]"
					[readonly]="false"
					[ngModel]="_selectedMortgage?.paymentFrequency"
					(debounce)="setPaymentFrequency($event)"
					(onSelect)="selectPaymentFrequency($event)"
				></app-dropdown>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Payment Date and Period</div>
				<app-input
					[ngModel]="_selectedMortgage?.paymentDue"
					(debounce)="setPaymentDue($event)"
				></app-input>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Payment Amount</div>
				<app-input
					type="cents"
					[startIcon]="ICON.DOLLAR"
					[ngModel]="_selectedMortgage?.regularPayments"
					(debounce)="setRegularPayments($event)"
				></app-input>
			</div>

			<hr />

			<h5>Dates</h5>
			<div class="intake-field">
				<div class="text-grey-darker">Interest Adjustment Date</div>
				<app-date-picker
					[ngModel]="_selectedMortgage?.interestAdjustmentDate"
					(ngModelChange)="setInterestAdjustmentDate($event)"
				></app-date-picker>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">First Payment Date</div>
				<app-date-picker
					[ngModel]="_selectedMortgage?.firstPaymentDate"
					(ngModelChange)="setFirstPaymentDate($event)"
				></app-date-picker>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Balance Due Date</div>
				<app-date-picker
					[ngModel]="_selectedMortgage?.maturityDate"
					(ngModelChange)="setMaturityDate($event)"
				></app-date-picker>
			</div>
			<div class="intake-field">
				<div class="text-grey-darker">Last Payment Date</div>
				<app-date-picker
					[ngModel]="_selectedMortgage?.lastPaymentDate"
					(ngModelChange)="setLastPaymentDate($event)"
				></app-date-picker>
			</div>
		</div>
	</app-container>
</div>
